import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

type SidebarFooterProps = {
	children?: React.ReactNode;
	className?: string;
};
const SidebarFooter = ({ children, className }: SidebarFooterProps) => {
	return (
		<div
			className={twMerge(
				clsx(
					'mt-auto flex flex-col shadow-[0_-2px_10px_0_rgba(0,0,0,0.05)] py-5 -mx-4 px-4',
					className,
				),
			)}
		>
			{children}
		</div>
	);
};

export default SidebarFooter;
